import React, { useCallback, useState } from 'react';
import { AnimatePresence } from 'motion/react';
import { Layout } from '../components/layout/Layout';
import { useApiJson } from '../hooks/useApi';
import { useAuth } from '../components/AuthProvider';
import { EventsPageContent } from '../components/events/EventsPageContent';
import { QuickRegisterDrawer } from '../components/events/QuickRegisterDrawer';
import type { Event } from '../types';

interface EventsDto {
  ok: boolean;
  events: Event[];
}

export function EventsPage() {
  const { member } = useAuth();
  const { data, loading, mutate } = useApiJson<EventsDto>('/api/events');
  const events = data?.events ?? [];
  const [registeringId, setRegisteringId] = useState<string | null>(null);
  const registeringEvent = events.find((e) => e.id === registeringId) ?? null;

  const handleQuickRegister = useCallback((event: Event) => setRegisteringId(event.id), []);
  const handleClose = useCallback(() => setRegisteringId(null), []);
  const handleRegistered = useCallback(() => void mutate(), [mutate]);

  return (
    <Layout>
      <div className="space-y-8">
        <header>
          <h1 className="text-2xl font-semibold text-[var(--color-text-primary)]">Events</h1>
          <p className="text-[var(--color-text-secondary)] text-sm mt-1">
            Community gatherings, activities, and past highlights.
          </p>
        </header>

        <EventsPageContent
          events={events}
          loading={loading}
          onQuickRegister={member ? handleQuickRegister : undefined}
        />
      </div>

      <AnimatePresence>
        {registeringEvent && member && (
          <QuickRegisterDrawer
            event={registeringEvent}
            member={member}
            onClose={handleClose}
            onRegistered={handleRegistered}
          />
        )}
      </AnimatePresence>
    </Layout>
  );
}
